export const TypeFilter = ({ selectedType, onTypeChange }) => {
  const types = [
    { value: null, label: 'Todos' },
    { value: 'directo', label: 'En Directo' },
    { value: 'grabado', label: 'Grabados' }
  ];

  return (
    <div className="flex gap-2" data-testid="type-filter">
      {types.map((type) => (
        <button
          key={type.value || 'all'}
          onClick={() => onTypeChange(type.value)}
          className={`px-4 py-2 text-xs uppercase tracking-widest transition-all duration-300 border ${
            selectedType === type.value
              ? 'border-[var(--primary)] bg-[var(--primary)] text-black'
              : 'border-white/10 text-white/70 hover:border-white/30'
          }`}
          data-testid={`type-filter-${type.value || 'all'}`}
        >
          {type.label}
        </button>
      ))}
    </div>
  );
};

export default TypeFilter;
